export function isInternalNotificationHref(href: string) {
    return href.startsWith("/")
        && !href.startsWith("//")
        && !href.startsWith("/\\");
}

export function isExternalNotificationHref(href: string) {
    if (!href.startsWith("https://")) {
        return false;
    }

    try {
        const url = new URL(href);
        return url.protocol === "https:" && Boolean(url.hostname);
    } catch {
        return false;
    }
}

export function isSafeNotificationHref(href: string) {
    return isInternalNotificationHref(href)
        || isExternalNotificationHref(href);
}

export function preserveNotificationCompanyParam(
    href: string,
    company: string | null,
) {
    if (!company || !isInternalNotificationHref(href)) {
        return href;
    }

    const url = new URL(href, "https://notification.internal");
    url.searchParams.set("company", company);
    return `${url.pathname}${url.search}${url.hash}`;
}
